import { useEffect, useState } from 'react';
import {  useLocation, useNavigate } from 'react-router-dom';
import s from './waiting-restore-page.module.scss';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import ReactCodeInput from 'react-code-input';
import { isBefore, subMinutes } from 'date-fns';
import { auth } from '@shared/api/services' ;
import { Button } from '@shared/ui/button/button';
import { CountdownTimer } from '@shared/ui/countdown-timer/countdown-timer';
import { useResetPasswordRequest } from '../api/useResetPasswordRequest';

const props = {
  className: s.inputsWrapper,
  inputStyle: {
    MozAppearance: "textfield",
    borderRadius: "0.5rem",
    border: "1px solid#E2E4E7",
    background: "#FFF",
    fontSize: "2rem",
    padding: "1rem 0.75rem",
    paddingLeft: "0.75rem",
    width: 53,
    textAlign: "center",
  },
  inputStyleInvalid: {
    border: "1px solid ##F12828",
  },
};

export const WaitingRestore = () => {
	const {state} = useLocation()
	const phone = state?.verifyPhone

	const {data: code, refetch} = useResetPasswordRequest({
		phone, 
		enabled: !localStorage?.getItem('resend_sms_available_at') || 
		isBefore(new Date(localStorage.getItem('resend_sms_available_at')), new Date())
	})
	
	const methods = useForm({ mode: "onTouched" });
	const navigate = useNavigate();

	const [startTime, setStartTime] = useState(null)
	const [error, setError] = useState(null)

  const [isExpired, setIsExpired] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

	const handleSubmit = methods.handleSubmit((data) => {
		const payload = {
			phone: phone,
			code: data?.code,
		};

		auth.resetPasswordVerify(payload).then((res) => {
			if (res.status === 200) {
				navigate("/set-new-password", {state: {
					reset_token: res?.data?.reset_token,
					phone
				}});
			}
		}).catch(err => {
			if(err?.response?.data?.message){
				setError(err?.response?.data?.message)
			}
		});
	});

	useEffect(() => {
		if(localStorage?.getItem('resend_sms_available_at')){
			setStartTime(subMinutes(new Date(code?.resend_available_at || localStorage?.getItem('resend_sms_available_at')), 5))
			setIsExpired(false)
			setButtonDisabled(false)
		}
	}, [code])

    return (
        <div className={s.wrapper}>
					<div className={s.card}>
						<h2 className={s.title}>
								Восстановление пароля
						</h2>
						<p className={s.message}>
								Для завершения процесса восстановления, введите код из СМС
						</p>
						<FormProvider {...methods}>
							<form onSubmit={handleSubmit} className={s.form}>
								{error && <span className={s.error}>{error}</span>}
								<Controller
									name="code"
									control={methods.control}
									defaultValue=""
									rules={{
										required: "Введите код",
										pattern: {
											value: /^\d{6}$/,
											message: "Код должен состоять из 6 цифр",
										},
									}}
									render={({ field }) => (
										<ReactCodeInput
											type="number"
											fields={6}
											{...field}
											{...props}
										/>
									)}
								/>
								<div className={s.countdownWrapper}>
									{isExpired ? (
											<>
												<button disabled={buttonDisabled} onClick={() => {
													setButtonDisabled(true)
													auth.resetPasswordRequest({phone}).then(el => {
														refetch()
														setButtonDisabled(false)
													})}}>
													Запросить код повторно
												</button>
											</>
										) : (
											<>
												Повторно запросить код можно будет через:{" "}
												{startTime && <CountdownTimer
													durationInSeconds={300}
													{...{ setIsExpired, startTime }}
												/>}
											</>
										)}
								</div>
								<Button
									label="Подтвердить"
									className={s.button}
									disabled={
										!methods?.formState?.isDirty || !methods?.formState?.isValid
									}
								/>
							</form>
							<button className={s.logout} onClick={() => navigate('/forget-password')}>Назад</button>
						</FormProvider>
            </div>
        </div>
    );
};